module.exports = __webpack_public_path__ + "static/media/tipenergia.b5da6b35.svg";